import { defineDictionary } from "gemi/client";

// The hero composer's store chip. The image and video chips still read the legacy HomePageV2
// dictionary; new copy goes here (the legacy API is frozen, see app/i18n/legacyI18nApi.test.ts).
export const heroPromptDict = defineDictionary({
  chip_store: {
    "en-US": "Create your store",
    "tr-TR": "Mağazanı oluştur",
    "de-DE": "Shop erstellen",
    "it-IT": "Crea il tuo negozio",
    "fr-FR": "Créer votre boutique",
    "es-ES": "Crea tu tienda",
    "ru-RU": "Создать магазин",
  },
  prompt_placeholder_store: {
    "en-US": "Tell us what you sell, or drop product photos...",
    "tr-TR": "Ne sattığınızı anlatın ya da ürün fotoğraflarınızı ekleyin...",
    "de-DE":
      "Erzählen Sie, was Sie verkaufen, oder legen Sie Produktfotos ab...",
    "it-IT": "Raccontaci cosa vendi o trascina le foto dei prodotti...",
    "fr-FR":
      "Dites-nous ce que vous vendez ou déposez des photos de produits...",
    "es-ES": "Cuéntanos qué vendes o suelta fotos de tus productos...",
    "ru-RU": "Расскажите, что вы продаёте, или перетащите фото товаров...",
  },
});
